import { h } from "vue";

const InputWrapper = function (props, context) {
  return h("div", { class: props.class }, [
    h("label", { for: props.id, class: "control-label" }, props.label),
    h(
      "div",
      {
        class: `form-control ${props.error ? "error" : ""} ${
          props.disabled ? "form-control--disabled" : ""
        }`,
      },
      context.slots
    ),
    props.errors.map(({ $message }, index) => {
      return h("div", { key: index, class: "error-message" }, $message);
    }),
  ]);
};

InputWrapper.props = ["id", "label", "class", "disabled", "error", "errors"];

export default InputWrapper;
